import React from "react";
import { Helmet } from "react-helmet-async";
import Logo from "assets/images/logo.png";
interface MetaTagsProps {}
export const MetaTags: React.FC<MetaTagsProps> = ({}) => {
  return (
    <Helmet>
      <title>OZB Connect</title>
      <meta
        name="description"
        content={
          "Download the OZB Connect app and manage all your bill payments from your smartphone. Fast, secure, and convenient."
        }
      />
      <meta name="keywords" content={"bill payment, airtime, recharge, "} />
      <meta
        property="og:title"
        content={
          "Bill payments made quick & easy with the OZB Connect app, download now, avialable on playstore and applestore "
        }
      />
      <meta
        property="og:description"
        content={
          "Download the OZB Connect app and manage all your bill payments from your smartphone. Fast, secure, and convenient."
        }
      />
      <meta property="og:image" content={Logo} />
      <meta property="og:url" content={window.location.href} />{" "}
      <meta property="og:type" content="website" />
      {/* ... other meta tags ... */}
    </Helmet>
  );
};


